module.exports = __webpack_public_path__ + "static/media/add-product-icon.1a52290a.svg";